






























































































































































































































































import {
  pickupStatus,
  SortFields,
  SortType,
} from '@/app/infrastructures/misc/Constants/pickupRadiusValidation'
import DataTableV2 from '@/app/ui/components/DataTableV2/index.vue'
import DateTimePickerV2, {
  IDateRangeValue,
} from '@/app/ui/components/DateTimePickerV2/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import {
  ICancelListParameters,
  ICancelListParams,
  IHeaderCell,
  IOptions,
  ITableCell,
  IValidationStatusMapper,
} from '@/data/infrastructures/misc/interfaces/cancelValidation'
import { Component, Vue, Watch } from 'vue-property-decorator'
import AscendingIcon from '@/app/ui/assets/ascending_icon.vue'
import { Utils } from '@/app/infrastructures/misc/Utils'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import { Cancel } from '@/domain/entities/CancelValidation'
import Badge from '@/app/ui/components/Badge/index.vue'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import controller from '@/app/ui/controllers/CancelValidationController'
import EmptyState from '@/app/ui/components/EmptyState/EmptyState.vue'
import Button from '@/app/ui/components/Button/index.vue'
import WidgetDownload from '@/app/ui/components/WidgetDownload/index.vue'
import ManageCourierController from '@/app/ui/controllers/ManageCourierController'
import { ShowCourierPhoneRequest } from '@/data/payload/api/ManageCourierRequest'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'
import CustomOverlayPanel from "@/app/ui/components/CustomOverlayPanel/index.vue";
import DropdownCheckbox from '@/app/ui/components/DropdownCheckbox/index.vue'
import MasterDataController from '@/app/ui/controllers/MasterDataController'

interface Summary {
  fraud: number
  needValidation: number
  valid: number
}

@Component({
  components: {
    DateTimePickerV2,
    DropdownSelect,
    TextInput,
    DataTableV2,
    AscendingIcon,
    LoadingOverlay,
    Badge,
    PaginationNav,
    EmptyState,
    Button,
    WidgetDownload,
    EyeIcon,
    EyeDisabledIcon,
    CustomOverlayPanel,
    DropdownCheckbox
  },
})
class CancelList extends Vue {
  controller = controller

  enumSelectedSort = SortType
  enumSortFields = SortFields
  enumPickupStatus = pickupStatus

  selectedSort: SortType | null = null
  tableData: ITableCell[][] = []

  visiblePhones: Record<string, string> = {}

  statusOptions: IOptions[] = [
    {
      label: 'Semua',
      value: '',
    },
    {
      label: 'Valid',
      value: '1',
    },
    {
      label: 'Invalid',
      value: '2',
    },
    {
      label: 'Need Validation',
      value: '0',
    },
  ]

  shipmentTypeOptions = [
    { label: 'Customer Apps', value: 'customer' },
    { label: 'Marketplace', value: 'marketplace' },
    { label: 'Aggregator', value: 'aggregator' },
    { label: 'Corporate', value: 'corporate' },
    { label: 'Delivery Order', value: 'delivery_order' },
  ]

  datepickerPresets = [
    {
      key: 'last31days',
      label: '31 Hari Terakhir',
      value: 31,
    },
  ]

  parameters: ICancelListParameters = {
    page: 1,
    perPage: 50,
    search: '',
    status: this.statusOptions[0],
    shipmentType: [],
    reasons: [],
    dateRange: {
      start: new Date(),
      end: new Date(),
    },
  }
  headers = [
    this.headerCellMapper('No.', '60px'),
    this.headerCellMapper('Shipment ID', '160px'),
    this.headerCellMapper('History ID', '160px'),
    this.headerCellMapper('Nama Kurir', '220px'),
    this.headerCellMapper('Waktu Cancel', '188px'),
    this.headerCellMapper('Alasan Cancel', '188px'),
    this.headerCellMapper('Status', '140px', 'center'),
    this.headerCellMapper('Aksi', '140px', 'center'),
  ]

  listData: ITableCell[][] = []
  summary: Summary = {
    fraud: 0,
    needValidation: 0,
    valid: 0,
  }

  isAllData = false

  created(): void {
    document.title = 'List Cancel | Content Management System | Lionparcel'
    this.getCancelListPickup(true)
    MasterDataController.getReasons();
  }

  get params(): ICancelListParams {
    return {
      page: this.parameters.page,
      perPage: this.parameters.perPage,
      keyword: this.parameters.search,
      status: this.parameters.status.value,
      startDate: <string>(
        Utils.formatDateWithIDLocale(
          <string>this.parameters.dateRange?.start?.toISOString(),
          'YYYY-MM-DD'
        )
      ),
      endDate: <string>(
        Utils.formatDateWithIDLocale(
          <string>this.parameters.dateRange?.end?.toISOString(),
          'YYYY-MM-DD'
        )
      ),
      column: this.selectedSort ? this.selectedSort.split('-')[0] : '',
      sortDirection: this.selectedSort ? this.selectedSort.split('-')[1] : '',
      isShowDetail: this.isAllData,
      reasonId: this.parameters.reasons.map(reason => this.reasonOptions.find(option => option.label === reason)?.value).join(","),
      shipmentType: this.parameters.shipmentType.map(shipment => this.shipmentTypeOptions.find(option => option.label === shipment)?.value).join(",")
    }
  }

  get filterCounter(): number {
    let count = 0
    if (this.parameters.status?.value !== '' && this.parameters.status?.value !== undefined && this.parameters.status?.value !== null) {
      count += 1
    }
    count += (this.parameters.shipmentType || []).length
    count += (this.parameters.reasons || []).length
    return count
  }

  get reasonOptions() {
    return MasterDataController.reasons.map((reason) => {
      return {
        label: reason.reason,
        value: reason.reasonId
      } as IOptions
    })
  }

  public getCancelListPickup(reset?: boolean): void {
    if (reset) {
      this.parameters.page = 1
    }
    this.visiblePhones = {};
    this.controller.getCancelList(this.params)
  }

  public onSearch = Utils.debounce((keyword: string) => {
    if (keyword.length === 0 || keyword.length > 2) {
      this.parameters.search = keyword
      this.getCancelListPickup(true)
    }
  }, 500)

  public onChangeStatus(status: IOptions): void {
    if (!status) {
      this.parameters.status = this.statusOptions[0]
    }
    this.getCancelListPickup(true)
  }

  public onChangeDateRange(value: IDateRangeValue): void {
    if (!value.start && !value.end) {
      this.parameters.dateRange = {
        start: new Date(),
        end: new Date(),
      }
    }
    this.getCancelListPickup(true)
  }

  public onTableSort(sortType: SortFields): void {
    switch (sortType) {
      case SortFields.COURIER_NAME:
        if (this.selectedSort === SortType.COURIER_NAME_ASC) {
          this.selectedSort = SortType.COURIER_NAME_DESC
        } else if (this.selectedSort === SortType.COURIER_NAME_DESC) {
          this.selectedSort = null
        } else {
          this.selectedSort = SortType.COURIER_NAME_ASC
        }
        break
      case SortFields.CREATED_AT:
        if (this.selectedSort === SortType.CREATED_AT_ASC) {
          this.selectedSort = SortType.CREATED_AT_DESC
        } else if (this.selectedSort === SortType.CREATED_AT_DESC) {
          this.selectedSort = null
        } else {
          this.selectedSort = SortType.CREATED_AT_ASC
        }
        break
    }
    this.getCancelListPickup(true)
  }

  public onExport(): void {
    const payload: Record<string, string | number> = {
      keyword: this.parameters.search,
      status: <string>this.parameters.status.value,
      startDate: <string>(
        Utils.formatDateWithIDLocale(
          <string>this.parameters.dateRange?.start?.toISOString(),
          'YYYY-MM-DD'
        )
      ),
      endDate: <string>(
        Utils.formatDateWithIDLocale(
          <string>this.parameters.dateRange?.end?.toISOString(),
          'YYYY-MM-DD'
        )
      ),
      filename: `CRRCNC-${Utils.formatDateWithIDLocale(
        new Date().toISOString(),
        'YYYYMMDDHHmmss'
      )}`,
      reasonId: this.parameters.reasons.map(reason => this.reasonOptions.find(option => option.label === reason)?.value).join(","),
      shipmentType: this.parameters.shipmentType.map(shipment => this.shipmentTypeOptions.find(option => option.label === shipment)?.value).join(","),
    }

    this.controller.exportCancelList(payload)
  }

  public validationStatusMapper(status: string): IValidationStatusMapper {
    switch (status) {
      case this.enumPickupStatus.VALID:
        return {
          text: 'Valid',
          color: 'success',
        }
      case this.enumPickupStatus.NEED_VALIDATION:
        return {
          text: 'Need<br>Validation',
          color: 'warning',
        }
      default:
        return {
          text: 'Invalid',
          color: 'error-1',
        }
    }
  }

  private headerCellMapper(
    title: string | number,
    colWidth: string,
    textAlign?: string
  ): IHeaderCell {
    return {
      title: title,
      customStyle: {
        minWidth: colWidth,
        maxWidth: colWidth,
        textAlign: textAlign,
      },
    }
  }

  private tableCellMapper(
    value: string | number | Date | string[],
    colWidth: string,
    justifyContent?: string
  ): ITableCell {
    return {
      value,
      customStyle: {
        maxWidth: colWidth,
        minWidth: colWidth,
        display: 'flex',
        justifyContent: justifyContent || '',
      },
    }
  }

  isPhoneVisible(rowIndex: number): boolean {
    return Boolean(this.visiblePhones[String(rowIndex)])
  }

  async togglePhone(rowIndex: number): Promise<void> {
    this.isAllData = !this.isAllData;
    const key = String(rowIndex)
    if (this.visiblePhones[key]) {
      this.$delete(this.visiblePhones, key)
    } else {
      const courierId = this.controller.cancelListData[rowIndex]?.courierId
      if (!courierId) return
      const phone = await ManageCourierController.showCourierPhone(
        new ShowCourierPhoneRequest({ id: courierId, source: 'cancel-validation-list', type: 'courier' })
      )
      if (phone) this.$set(this.visiblePhones, key, phone)
    }
    // Rebuild the composite label with updated phone
    const item = this.controller.cancelListData[rowIndex]
    if (!item) return
    const phone = this.visiblePhones[key] || '********'
    this.tableData[rowIndex][3] = this.tableCellMapper(
      `[${item.courierId}] ${item.courierName} </br> (${item.courierTypeValid}) ${phone}`,
      '220px'
    )
  }

  appliedFilters = {
    status: this.statusOptions[0],
    shipmentType: [] as string[],
    reasons: [] as string[],
  }

  onApplyFilter(): void {
    this.appliedFilters = {
      status: this.parameters.status,
      shipmentType: [...this.parameters.shipmentType],
      reasons: [...this.parameters.reasons],
    }
    this.getCancelListPickup(true)
  }

  onCancelFilter(): void {
    this.parameters.status = this.appliedFilters.status
    this.parameters.shipmentType = [...this.appliedFilters.shipmentType]
    this.parameters.reasons = [...this.appliedFilters.reasons]
  }

  onResetFilter(): void {
    this.parameters.reasons = []
    this.parameters.status = this.statusOptions[0]
    this.parameters.shipmentType = []
    this.appliedFilters = {
      status: this.statusOptions[0],
      shipmentType: [],
      reasons: [],
    }

    this.getCancelListPickup(true)
  }

  @Watch('controller.cancelListData')
  onSetCancelListData(data: Cancel[]): void {
    this.tableData = data.map((cancel, index) => {
      return [
        this.tableCellMapper(
          index +
            1 +
            this.parameters.perPage * (this.parameters.page - 1) +
            '.',
          '60px',
          'center'
        ),
        this.tableCellMapper(
          cancel.bookingId
            ? <string[]>[cancel.shipmentId, cancel.bookingId]
            : <string[]>[cancel.shipmentId],
          '160px'
        ),
        this.tableCellMapper(<number>cancel.historyId, '160px'),
        this.tableCellMapper(
          `[${cancel.courierId}] ${cancel.courierName} </br> (${cancel.courierTypeValid}) ********`,
          '220px'
        ),
        this.tableCellMapper(
          <string>(
            Utils.formatTimeZone(
              Utils.formatDateWithIDLocale(
                <string>cancel.createdAt,
                'DD MMM YYYY HH:mm Z'
              )
            )
          ),
          '188px'
        ),
        this.tableCellMapper(<string>cancel.cancelReason, '188px'),
        this.tableCellMapper(<string>cancel.cancelStatus, '140px', 'center'),
        this.tableCellMapper(<number>cancel.historyId, '140px', 'center'),
      ]
    })
  }

  @Watch('controller.cancelSummaryData')
  onSetCancelSummaryData(data: Summary): void {
    this.summary = data
  }
}

export default CancelList;
